import React from "react";
import { motion } from "framer-motion";
import { Reveal, Overline } from "./Reveal";
import { PHOTOS } from "../lib/assets";

const PROJECTS = [
  { title: "Kensington Residence", tag: "Full Home · 3BHK", img: PHOTOS.living1, span: "md:col-span-7" },
  { title: "The Clay Kitchen", tag: "Modular Kitchen", img: PHOTOS.kitchen1, span: "md:col-span-5" },
  { title: "Arch House Bedroom", tag: "Master Suite", img: PHOTOS.bedroom1, span: "md:col-span-5" },
  { title: "Northline Living", tag: "Living & Storage", img: PHOTOS.living3, span: "md:col-span-7" },
];

export default function Portfolio() {
  return (
    <section id="portfolio" className="py-24 md:py-32 bg-white border-y border-navy/10" data-testid="portfolio-section">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div>
            <Reveal><Overline>Selected work</Overline></Reveal>
            <Reveal delay={0.05}>
              <h2 className="font-display text-4xl md:text-6xl font-light tracking-tight text-navy mt-5 leading-[1.02]">
                Homes we designed,<br />installed &amp; delivered.
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.1}>
            <p className="text-ink/70 md:max-w-xs md:text-right leading-relaxed">
              A restrained, material-led portfolio — every project handled from first sketch to final key.
            </p>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-12 gap-4 md:gap-6">
          {PROJECTS.map((p, i) => (
            <Reveal key={p.title} delay={i * 0.06} className={p.span}>
              <motion.div whileHover={{ y: -6 }} transition={{ type: "spring", stiffness: 280, damping: 24 }}
                className="group relative overflow-hidden border border-navy/10" data-testid={`portfolio-item-${i}`}>
                <div className="overflow-hidden aspect-[16/11]">
                  <img src={p.img} alt={`${p.title} — ${p.tag} home interior project by DIDIT`} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-navy/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                <div className="absolute bottom-0 left-0 p-6 translate-y-2 group-hover:translate-y-0 transition-transform duration-500">
                  <p className="text-[11px] tracking-[0.25em] uppercase text-terracotta font-semibold">{p.tag}</p>
                  <h3 className="font-display text-2xl md:text-3xl text-warm font-light mt-1">{p.title}</h3>
                </div>
              </motion.div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
